import React from "react";
import {
  ResponsiveContainer,
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  Legend,
} from "recharts";
import { VerticalData } from "./types";

interface Props {
  data: VerticalData[];
}

const DashboardChart: React.FC<Props> = ({ data }) => {
  if (!data?.length) return <div>No data available</div>;

  const chartData = data.map(v => ({
    name: v.vertical_name,
    inquiries: v.inquiries || 0,
    won: v.inquiries_won || 0,
    high: v.high_probability || 0,
    rfq: v.rfq_pending || 0,
    quotation: v.quotation_pending || 0,
    lost: v.lost_enquiries || 0,
      today: v.today_activities || 0,
  tomorrow: v.tomorrow_activities || 0,

  }));

  return (
    <ResponsiveContainer width="100%" height={300}>
      <BarChart data={chartData}>
        <XAxis dataKey="name" />
        <YAxis />
        <Tooltip />
        <Legend />

        {/* colors SAME as cards */}
        <Bar dataKey="inquiries" fill="#9ec3d6" name="Inquiries" />
        <Bar dataKey="won" fill="#9bd2a5" name="Inquiries Won" />
        <Bar dataKey="high" fill="#e7df98" name="High Probability" />
        <Bar dataKey="rfq" fill="#c4bde5" name="RFQ Pending" />
        <Bar dataKey="quotation" fill="#e7caa6" name="Quotation Pending" />
        <Bar dataKey="lost" fill="#e6b2b2" name="Lost Inquiries" />
       <Bar dataKey="today" fill="#8fd1c7" name="Today's Activities" />
<Bar dataKey="tomorrow"  fill="#bfa6e7" name="Tomorrow's Activities" />
      </BarChart>
    </ResponsiveContainer>
  );
};

export default DashboardChart;
